import * as React from "react";

import {ControlTypeEnum} from "PageBuilder/pagebuilder/Controls/NormalPDFControlFactory";
import {PRControlTypes} from "../../../../../PageBuilderPr/PRControlFactory";
import {FieldItemBase, FieldItemBaseProps, FieldItemBaseState} from "InternalShared/PageBuilder/Fields/FieldItemBase";



export class HtmlFieldItem extends FieldItemBase<TextFieldItemProps, TextFieldItemState> {
    static defaultProps: Partial<TextFieldItemProps> = {};
    IsPR:boolean=true;
    constructor(props: TextFieldItemProps) {
        super(props);
        this.state = {

        };
    }

    protected GetImage() {
        return 'code.png'
    }

    protected GetText() {
        return 'HTML'
    }

    protected GetType() {
        return PRControlTypes.HTML;
    }

}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface TextFieldItemProps extends FieldItemBaseProps{

}

interface TextFieldItemState extends FieldItemBaseState{

}

//#endregion "My Region"